import React from "react";

import { useParams } from "react-router-dom";

import * as IconsSVG from "../../assets/iconsSVG";
import images from "../../constants/images";
import * as Styles from "./styles";

interface params {
  action: string;
}

const ShareConfirm = () => {
  const params: params = useParams();

  return (
    <Styles.Container>
      <Styles.Content>
        <Styles.HeaderContent>
          <Styles.BoxImgSuccess>
            <IconsSVG.SuccessIcon />
          </Styles.BoxImgSuccess>
          <Styles.HeaderTitle>Lead {params.action}</Styles.HeaderTitle>
        </Styles.HeaderContent>
        <Styles.InfoContent>
          <Styles.TitleInfo>
            Este lead não será mais exibido na sua carteira
          </Styles.TitleInfo>
          <Styles.BoxImgArt>
            <img src={images.transferSuccessArt} alt="Art Success" />
          </Styles.BoxImgArt>
          <Styles.LinkReturn href="/leads">
            Voltar para a carteira
          </Styles.LinkReturn>
        </Styles.InfoContent>
      </Styles.Content>
    </Styles.Container>
  );
};

export default ShareConfirm;
